"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var NotificationSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M9,3 C11.209139,3 13,4.790861 13,7 L13,9.5 C13,9.71897456 13.0489654,9.82795546 13.2552152,10.0457876 L13.3535534,10.1464466 C13.7679147,10.5608079 13.9600474,10.853405 13.9943303,11.3328437 L14,11.5 L14,12 C14.0003095,12.5128358 13.6142914,12.9355072 13.1169543,12.9932723 L13,12.9996667 L11,12.999 C11,14.0543618 10.1841222,14.9181651 9.14926234,14.9945143 L9,15 C7.9456382,15 7.08183488,14.1841222 7.00548574,13.1492623 L7,12.999 L5,12.9996667 C4.48716424,13.0001471 4.06436427,12.6142699 4.00643338,12.1169521 L4,12 L4,11.5 L4.00566967,11.3328437 C4.03614338,10.906676 4.19133789,10.6281362 4.51646855,10.2804806 L4.74478481,10.0457876 C4.92157031,9.85907433 4.98279999,9.75233341 4.99668632,9.58774997 L5,9.5 L5,7 C5,4.790861 6.790861,3 9,3 Z M10,12.999 L8,12.999 C8,13.5128358 8.38604019,13.9355072 8.88337887,13.9932723 L9,14 C9.51283584,14 9.93550716,13.6139598 9.99327227,13.1166211 L10,12.999 Z M9,4 C7.34314575,4 6,5.34314575 6,7 L6,9.5 C6,10.024769 5.84930344,10.3284069 5.48353145,10.7195194 L5.25521519,10.9542124 C5.07842969,11.1409257 5.01720001,11.2476666 5.00331368,11.41225 L5,11.5 L5.001,12 L12.999,12 L13,11.5 C13,11.2810254 12.9510346,11.1720445 12.7447848,10.9542124 L12.6464466,10.8535534 C12.1860451,10.3931519 12,10.0830767 12,9.5 L12,7 C12,5.34314575 10.6568542,4 9,4 Z" })));
};
NotificationSmall.displayName = 'NotificationSmall';
exports.default = NotificationSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=NotificationSmall.js.map